<template>
  <div class="control-input">
    <a v-on:click="showdetails">
      <div v-if="thisNodeIsHighlightOwner">
        <!-- SVG that is shown if this node is NOT the highlight owner -->
        <svg width=140 height=100 class="plot-preview" v-if="canPreviewBeShown">
          <!-- SVG that is shown if preview CAN be shown -->
          <path :d="pathvalues" stroke="#4B4B4B" fill="#51A7DD" stroke-width=1 stroke-linejoin="round"></path>
          <!-- Adding highlight rectangle(s) below; we need two if sliders are crossed -->
          <path :d="pathHighlightLine1ForHighlightOwningNode" stroke="#FFD200" fill="#FFD200" fill-opacity="0.6" stroke-width=1 stroke-linejoin="round"></path>
          <path :d="pathHighlightLine2ForHighlightOwningNode" stroke="#FFD200" fill="#FFD200" fill-opacity="0.6" stroke-width=1 stroke-linejoin="round"></path>
        </svg>
        <svg width=140 height=100 class="plot-preview" v-else>
          <!-- SVG that is shown if preview CANNOT be shown -->
          <text v-html="previewMessage" dominant-baseline="middle" text-anchor="middle" class="heavy" style="font: italic 10px sans-serif;">
          </text>
        </svg>
      </div>
      <div v-else>
        <!-- SVG that is shown if this node IS the highlight owner -->
        <svg width=140 height=100 class="plot-preview" v-if="canPreviewBeShown">
          <!-- SVG that is shown if preview CAN be shown -->
          <path :d="pathvalues" stroke="#4B4B4B" fill="#51A7DD" stroke-width=1 stroke-linejoin="round"></path>
          <path :d="highlightvalues" stroke="#FFD200" stroke-width=1 fill="#FFD200" fill-opacity="0.6" stroke-linejoin="round"></path>
        </svg>
        <svg width=140 height=100 class="plot-preview" v-else>
          <!-- SVG that is shown if preview CANNOT be shown -->
          <text v-html="previewMessage" dominant-baseline="middle" text-anchor="middle" class="heavy" style="font: italic 10px sans-serif;">
          </text>
        </svg>        
      </div>
    </a>
  <div class="tooltip" v-if="thisNodeIsHighlightOwner">
    <!-- The dot below is the yellow dot that indicates that highlight was defined here -->
    <span class="dot"></span>
    <span class="tooltiptext">The highlight was defined in this node.</span>
  </div>
  </div>
</template>

<script>
  import plotDetailPopUpGraph from '../../util/density/plotDetailPopUpGraph';
  import Vue from 'vue';

  export default {
    name: 'VueDistPreview',
    props: [
      'readonly',
      'emitter',
      'ikey',
      'getData',
      'putData',
      'nodeID' // in the reteExtensions/index.js, the constructor of each type of dist passes the node's ID to the constructor of VueDistPreview
    ],
    
    data: () => {
      return {
        previewAvailable: true, // can we show a preview of the dist?
        pathvalues: "",         // path values of the distribution provided by reteExtensions/index.js
        canPreviewBeShown: true,
        previewMessage: '',
        highlightvalues: "",
        arrayvalues: undefined,
        // these below are the arrayvalues but for each time period, we have only used the first X values
        // ..where X is SPURS.maxNumberOfSamplesUsedInPreviewAndForKLDivergence
        arrayValuesTruncatedForPreview: undefined,  
        thisNodeIsHighlightOwner: false,
        pathHighlightLine1ForHighlightOwningNode: '',
        pathHighlightLine2ForHighlightOwningNode: '',
        density: undefined,
        highlightDensity: undefined,
        klDivergence: undefined,
      }
    },
    mounted() {

      //this.value = this.getData(this.ikey);
      // console.log('node id', this.nodeID)

      // event listener for events emitted by the highlight-owning dist preview
      Vue.prototype.$eventHub.$on('DistPreviewPleaseUpdate', (data) => {
   
        // console.log('data in DistPreviewPleaseUpdate', data);

        // This VueDistPreview should only ever do anything if data.nodeID matches its own node ID (that was passed into its constructor upon creation).
        // Otherwise nothing should happen. Each node sends an event to its VueDistPreview.

        if (this.nodeID == data.nodeID){
          this.updateDistPreview(data)
        }
      });
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('DistPreviewPleaseUpdate');
    },
    methods: {
      showdetails(){
        // If the node has not been renamed yet, it is undefined
        let givenName = this._props.emitter.selected.list[0].data.title
        if (typeof givenName == 'undefined'){
          givenName = Vue.prototype.$globalSharedData.defaultPopupName;

          // Remove the name of the node that owns the highlight
          Vue.prototype.$globalSharedData.nameOfNodeThatOwnsHighlight = undefined;
        } else {

          // Write the name of the node into the global variables
          Vue.prototype.$globalSharedData.nameOfNodeThatOwnsHighlight = this._props.emitter.selected.list[0].data.title;

        }

        plotDetailPopUpGraph(this.arrayvalues, givenName, undefined, undefined, this._props.emitter.selected.list[0].id, this._uid);

      },
      updateDistPreview(data){

        // console.log('data in updateDistPreview', data);

        // Update highlight indicator (this variable is reactive)
        this.thisNodeIsHighlightOwner = data.thisNodeIsHighlightOwner;

        this.arrayValuesTruncatedForPreview = data.matrixTruncatedForPreview;
        this.pathvalues = data.pathvalues;
        this.density = data.density;
        this.highlightDensity = data.densityHighlight;
        this.highlightvalues = data.highlightLine;
        this.klDivergence = data.klDivergence;
        this.canPreviewBeShown = data.canPreviewBeShown;
        this.previewMessage = data.previewMessage;
        this.pathHighlightLine1ForHighlightOwningNode = data.pathHighlightLine1ForHighlightOwningNode;
        this.pathHighlightLine2ForHighlightOwningNode = data.pathHighlightLine2ForHighlightOwningNode;

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .plot-preview {
    border: 1px solid rgba(192, 192, 192, 0.7);
  }

  .plot-preview:hover {
    border: 1px solid #4B4B4B;
  }

  /* highlight indicator: if yellow, then this node defines highlight */
  .dot {
    height: 15px;
    width: 15px;
    background-color: yellow;
    border-radius: 50%;
    border-color: black;
    border-width: thin;
    display: inline-block;
    margin-left: 10px;

  }

</style>
